import { EmptyModuleDark, EmptyModuleLight } from "@kirvanobr/custom-icons";
import { useTheme } from "next-themes";
import { styles } from "./EmptyContent.styles";
import { EmptyContentProps } from "./EmptyContent.types";

/**
 *
 * @param icon (optional) ReactNode
 * - Use icon prop to especify what icon should be used
 *
 * @param children ReactNode
 * - Texts used inside this component
 */
export const EmptyContent = ({ children, icon }: EmptyContentProps) => {
  const { theme } = useTheme();

  return (
    <div className={styles().base()}>
      <div className={styles().iconWrapper()}>
        {icon ? icon : theme === "dark" ? <EmptyModuleDark fontSize={130} /> : <EmptyModuleLight fontSize={130} />}
      </div>
      <div className={styles().textsWrapper()}>{children}</div>
    </div>
  );
};
